interface EnumItem {
  label: string;
  value: string | number;
}

export const state = {
  sidebarStatus: "open",
  filterStatus: false,
  selectedExpandedRow: {
    blockType: '',
    eventId: '',
    hash: '',
    filterData: {
      startDate: '',
      endDate: ''
    }
  },
  loader: false,
  companies: [],
  sites: [],
  groups: [],
  companyAssets: [],
  permissionLevels: [],
  reviewStatuses: [],
  riskLevels: [],
  settings: {},
  smtpSettings: {},
  sections: {},
  scopeDetail: {},
  agmsBreadcrumbStatus: false,
  agmsBreadcrumbData: {},
  alert: {
    status: false,
    options: {},
  },
  users: [],
  partners: [],
  compKey: 0,
  exportStatus: false,
  exportDataLoaded: false,
  selectedDecision: null,
  rowOpened: 0,
  isModalCreate: false,
  scopeModalStatus: false,
  appGroups: [],
  appGroupsProcess: [],
  appGroupsFileAccess: [],
  appGroupsRegistryAccess: [],
  appGroupsCodeLoad: [],
  appGroupsChildLaunch: [],
  globalPolicies: [],
  globalPolicyFileAccess: [],
  globalPolicyRegistryAccess: [],
  accessControl: [],
  appliesTo: [],
  enums: {} as Record<string, EnumItem[]>,
  folderMaps: [],
  publisherList: [],
  appGroupInfo: {},
  globalPolicyCodeLoad:[],
  fileTypesPolicies: [],

};

export type State = typeof state;
